import Colors from '../../constants/Colors';

export default {
  editorContainer: {
    display: 'flex',
    flexDirection: 'column',
    // borderTop: `1px solid darkgray`,
    // borderBottom: `1px solid darkgray`,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    overflow: 'hidden',
    paddingBottom: 16,
  },

  textContainer: {
    fontWeight: 'bold',
    color: Colors.darkText,
    padding: 8,
    fontSize: 14,
    // borderRight: `1px solid darkgray`,
    // borderLeft: `1px solid darkgray`,
  },

  header: {
    backgroundColor: Colors.headerBackground,
    padding: 8,
    display: 'flex',
    gap: 4,
  },

  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 8,
  },

  saveButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 8,
  },

  duplicateLegalTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 8,
    marginTop: 8,
  },

  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: Colors.headerBackground,
    alignItems: 'center',
    paddingRight: 8,
  },

  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    flex: 1,
    width: '100%',
  },

  deactivateButton: {
    backgroundColor: '#B42318',
    borderColor: '#FDA29B',
    color: 'white',
    padding: '4px 26px',
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.14)',
  },
};
